import { Outlet, useLocation } from "react-router-dom";
import AmbientDotNetwork from "@/components/AmbientDotNetwork";

/**
 * Layout wrapper for all public-facing routes (everything except /dashboard/*).
 * Provides the shared dark theme scope, a persistent navy→teal gradient
 * background, and the ambient dot/connector network — mounted once so it
 * persists across page navigation within the public site.
 *
 * The mouse-driven traffic-light workflow is enabled on the homepage only;
 * all other public pages keep the calm drifting dots.
 */
const PublicChrome = () => {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  return (
    <div className="public-theme relative min-h-screen text-foreground">
      {/* Persistent diagonal navy → teal gradient, full viewport */}
      <div
        aria-hidden="true"
        className="fixed inset-0 -z-20"
        style={{
          background:
            "linear-gradient(135deg, hsl(var(--navy-deep)) 0%, #063d3a 55%, #00695C 80%, #008475 100%)",
        }}
      />
      <AmbientDotNetwork interactive={isHome} />
      <Outlet />
    </div>
  );
};

export default PublicChrome;
